<template>
  <div class="container-fluid base" id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/common/header.vue'
import Footer from './components/common/footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  created () {
    // this.$i18n.locale = 'en-US'
    // this.$i18n.locale = 'zh-CN'
  }
}

</script>
<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue